<template>
  <v-slide-y-transition mode="out-in">
    <v-container v-if="currentProd != null" fluid fill-height class="scroll-y">
      <v-tabs dark v-model="active" :class="{ fromMenu: fromMenu }">
        <v-tabs-slider class="grey"></v-tabs-slider>

        <v-tab href="#anagra" ripple>Anagrafica</v-tab>
        <v-tab-item value="anagra">
          <v-card class="card-content-fill" flat>
            <v-card-text>
              <v-card class="elevation-4 grey darken-4">
                <v-card-title>
                  <h3 class="headline mb-0">
                    Proprietà generali
                  </h3>
                  <v-spacer></v-spacer>
                  <v-switch                    
                    :class="setCheckboxClass(currentProd)"
                    hint="Marca questo articolo come favorito"
                    label="Favorito"
                    @click.native="update"
                    v-model="currentProd.isFavorite"
                  ></v-switch>
                </v-card-title>
                <v-card-text>
                  
                  <div class="cod-container">
                    <v-text-field :disabled="fromMenu || keepSync" label="Codice" v-model="currentProd.ctvlx"></v-text-field>
                    <v-btn :disabled="fromMenu || keepSync" @click.native="generateCode" fab small primary>
                      <v-icon>cached</v-icon>
                    </v-btn>
                  </div>
                  <DescrEditor
                    v-model="currentProd.descrizione"
                    :currentLang="currentLang"
                    @changeLang="changeLang"
                    @setDescr="setDescr"
                    :keepSync="false && !fromMenu && keepSync && currentProd.ctvlx != null"
                  />
                  <DescrEditor
                    v-if="!fromMenu && keepSync"
                    v-model="currentProd.externalDescription"
                    :currentLang="tavolinuxLang"
                    :keepSync="true"
                    labelOverride="Descrizione in Tavolinux"
                  />
                  <DescrEditor
                    v-model="currentProd.billDescription"
                    :currentLang="currentLang"
                    @changeLang="changeLang"
                    @setDescr="setDescrConto"
                    labelOverride="Descrizione Conto"
                  />
                  <v-text-field v-model="currentProd.orderDescription" label="Descrizione Comanda" style="margin-right: 30px"></v-text-field>
                  <DescrEditor
                    v-if="['prod', 'var', 'ingr', 'tag'].includes(currentProd.tipo)"
                    v-model="currentProd.descrizioneEstesa"
                    :currentLang="currentLangExt"
                    :multi="true"
                    @changeLang="changeLangExt"
                    @setDescr="setDescrExt"
                  />
                </v-card-text>
              </v-card>
              <v-card class="elevation-4 grey darken-4 mb-2">
                <v-card-title>
                  <h3 class="headline">Limiti</h3>
                </v-card-title>
                <v-card-text>
                  <v-text-field
                    v-if="currentProd.tipo == 'prod'"
                    type="number"
                    label="Max varianti selezionabili"
                    hint="Se lasciato vuoto viene ereditato dal gruppo"
                    v-model="currentProd.extraProps.prodMaxVar"
                    pattern="[0-9]"
                  ></v-text-field>
                  <v-text-field
                    v-if="currentProd.tipo == 'prod' && fromMenu"
                    type="number"
                    label="Max ordinabile per coperto"
                    hint="Se lasciato vuoto o 0 è illimitato"
                    v-model="currentProd.limitedOrderability"
                    pattern="[0-9]"
                  ></v-text-field>                  
                  <v-combobox
                    v-if="['var', 'ingr'].includes(currentProd.tipo)"
                    v-model="currentProd.constraintTags"
                    :items="getAllUsedTags()"
                    multiple
                    return-object
                    label="Tag"
                    no-data-text="Nessun Tag inserito"
                    chips
                    deletable-chips
                    item-text="name"
                  ></v-combobox>

                  <v-card 
                    class="elevation-5 grey darken-4 mb-2"
                    v-if="!fromMenu && currentProd.tipo == 'prod'">
                    <v-card-title>
                      <h4>Vincoli gruppi</h4>
                    </v-card-title>
                    <v-card-text>
                      <v-form ref="manding">
                        <template v-for="(ingredient, index) in currentProd.extraProps.mandatoryIngredients">                        
                            <v-layout row wrap :key="index">
                              <v-flex xs12 md1>
                                  <v-autocomplete
                                    v-model="currentProd.extraProps.mandatoryIngredients[index].tag"
                                    :items="getAllUsedTags(index)"
                                    persistent-hint                                    
                                    hint="Tag degli ingredienti/varianti"
                                    label="Tag"
                                    no-data-text="Nessun tag inserito"
                                    item-text="name"
                                    required
                                  ></v-autocomplete>        
                                </v-flex>
                              <v-spacer></v-spacer>
                              <v-flex xs12 md2>
                                <v-text-field                                          
                                    persistent-hint
                                    hint="Descrizione"
                                    label="Descrizione su menu"
                                    v-model="currentProd.extraProps.mandatoryIngredients[index].description"
                                ></v-text-field>
                              </v-flex>
                              <v-spacer></v-spacer>
                              <v-flex xs12 md2>
                                <v-text-field                                          
                                    persistent-hint
                                    hint="Descrizione di suggerimento pop-up sull'app in caso di mancato inserimento di ingredienti/varianti"
                                    label="Descrizione di suggerimento (es. GUSTI)"
                                    v-model="currentProd.extraProps.mandatoryIngredients[index].suggestionDescr"
                                ></v-text-field>
                              </v-flex>
                              <v-spacer></v-spacer>                              
                              <v-flex xs12 md1>
                                <v-text-field
                                  type="number"
                                  placeholder="1"
                                  persistent-hint
                                  hint="Minimo numero di elementi"
                                  label="Quantità obbligatoria"
                                  pattern="[0-9]"
                                  min="0"
                                  v-model="currentProd.extraProps.mandatoryIngredients[index].requiredQuantity"
                                ></v-text-field>
                              </v-flex>
                              <v-spacer></v-spacer>
                              <v-flex xs12 md1>
                                <v-text-field
                                  type="number"
                                  placeholder="1"
                                  persistent-hint
                                  hint="Numero massimo di elementi (se indicato)"
                                  label="Quantità massima"
                                  pattern="[0-9]"
                                  min="0"
                                  v-model="currentProd.extraProps.mandatoryIngredients[index].maxRequiredQuantity"
                                ></v-text-field>
                              </v-flex>
                              <v-spacer></v-spacer>
                              <v-flex xs12 md1>
                                <v-autocomplete
                                    v-model="currentProd.extraProps.mandatoryIngredients[index].variantsTag"
                                    :items="getAllUsedTags(index)"
                                    persistent-hint                                    
                                    hint="Mostra le varianti con questo tag"
                                    label="Tag varianti"
                                    no-data-text="Nessun tag inserito"
                                    item-text="name"                                    
                                  ></v-autocomplete>  
                              </v-flex>
                              <v-spacer></v-spacer>
                              <v-flex xs12 md1>
                                <v-text-field
                                  type="number"
                                  placeholder="0"
                                  persistent-hint
                                  hint="Massimo varianti selezionabili"
                                  label="Max Tag varianti"
                                  pattern="[0-9]"
                                  min="0"
                                  v-model="currentProd.extraProps.mandatoryIngredients[index].maxVariantsTag"
                                ></v-text-field>
                              </v-flex>
                              <v-spacer></v-spacer>
                              <v-flex xs12 md1>
                                <v-icon @click="deleteMandatoryIngredient(index)">cancel</v-icon>
                              </v-flex>
                            </v-layout>
                          </template>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn flat color="orange" @click="addMandatoryIngredient"><v-icon dark>add</v-icon>Aggiungi vincolo</v-btn>
                    </v-card-actions>
                  </v-card>                 
                </v-card-text>
              </v-card>
              <v-card class="elevation-4 grey darken-4 mb-2" v-if="!fromMenu && ['prod','comb'].includes(currentProd.tipo)">
                <v-card-title
                  ><h3 class="headline">
                    Giorno specifico di validità
                  </h3>
                </v-card-title>
                <v-card-text>
                  <v-flex xs12 sm6 md4>
                    <v-dialog ref="dialog" v-model="specificDateSelector" :return-value.sync="specificDate" persistent lazy full-width width="290px">
                      <template v-slot:activator="{ on }">
                        <v-layout row>
                            <v-text-field
                              v-model="specificDateFormatted"
                              label="Scelta giorno/i"
                              hint="Formato gg/mm/aa"
                              persistent-hint
                              prepend-icon="event"
                              @blur="specificDate = parseDate(specificDateFormatted)"
                              readonly
                              v-on="on"
                            ></v-text-field>
                            <v-icon @click="clearSpecificDate()">cancel</v-icon>
                        </v-layout>
                      </template>
                      <v-date-picker v-model="specificDate" scrollable locale="it-IT">
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="specificDateSelector = false">Cancella</v-btn>
                        <v-btn flat color="primary" @click="$refs.dialog.save(specificDate)">OK</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-flex>
                </v-card-text>
              </v-card>
              <v-card class="elevation-4 grey darken-4 mb-2" v-if="!keepSync">
                <v-card-title
                  ><h3 class="headline">
                    Codici a barre
                  </h3></v-card-title
                >
                <v-card-text>
                  <v-list class="grey darken-4" two-line>
                    <v-form>
                      <template v-for="(barCode, index) in currentProd.barCodes">
                        <v-list-tile avatar :key="index">
                          <v-list-tile-avatar>
                            <span>{{ index + 1 }}</span>
                          </v-list-tile-avatar>

                          <v-list-tile-content>
                            <v-text-field
                              type="text"
                              style="
                                                                width: 100% !important;
                                                                margin-bottom: 0 !important;
                                                            "
                              placeholder="Barcode"
                              v-model="currentProd.barCodes[index]"
                              v-validate.immediate="'required|uniqueValidation:' + index"
                              :data-vv-name="'barCodes.barCode' + index"
                              :error-messages="errors.first('barCodes.barCode' + index)"
                              required
                              @input="confirmRequired"
                            ></v-text-field>
                          </v-list-tile-content>

                          <v-list-tile-action>
                            <v-icon @click="deleteBarCode(index)">close</v-icon>
                          </v-list-tile-action>
                        </v-list-tile>
                      </template>
                    </v-form>
                  </v-list>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn flat color="orange" @click="addBarCode"><v-icon dark>add</v-icon> Aggiunge Codice</v-btn>
                </v-card-actions>
              </v-card>
              <template v-if="['tag'].includes(currentProd.tipo) && !keepSync">
                <v-switch
                  :persistent-hint="true"
                  class="showHint"
                  hint="Altrimenti verranno ereditate dal gruppo padre"
                  @change="toggleOverrideStampanti"
                  primary
                  label="Sovrascrivi stampanti"
                  v-model="overrideStampanti"
                ></v-switch>
                <v-select
                  v-if="overrideStampanti"
                  chips
                  multiple
                  :items="stampanti"
                  v-model="currentProd.stampante"
                  label="Selezionare la stampanti di uscita"
                  item-value="name"
                  item-text="name"
                ></v-select>
              </template>
              <ChipEditor
                v-if="!['tag'].includes(currentProd.tipo) && !fromMenu"
                :frommenu="fromMenu"
                :resource="currentProd.tags"
                :callback="addGruppo"
                title="Gruppi"
                generator="newTag"
                type="Tag"
                :listino="fromMenu ? listinoDaMenu : currentListino"
                :keepSync="keepSync"
              />
              <ChipEditor
                v-if="['tag'].includes(currentProd.tipo) && !fromMenu"
                :frommenu="fromMenu"
                :resource="currentProd.padre"
                :callback="addGruppo"
                title="Gruppo padre"
                generator="newTag"
                type="Tag"
                unique="true"
                :listino="fromMenu ? listinoDaMenu : currentListino"
                :keepSync="keepSync"
              />
              <ChipEditor
                v-if="['tag', 'prod'].includes(currentProd.tipo)"
                :frommenu="fromMenu"
                :resource="currentProd.varIngr"
                :callback="addVarIngr"
                :title="titoloVarIngr"
                generator="newVarIngr"
                type="ProdVarIngr"
                :filter="[currentProd._id, ...currentProd.tags]"
                :listino="fromMenu ? listinoDaMenu : currentListino"
                :keepSync="keepSync"
                @sorted="indexes => onChipSort(indexes, currentProd.varIngr)"
                @order="ordered => onChipABCsort('varIngr', ordered)"
                @cloneVariants="() => onCloneProductVariants()"
              />
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab v-if="!['tag'].includes(currentProd.tipo) || currentProd.isComb || inComb" href="#gestione" ripple>Gestione</v-tab>
        <v-tab-item value="gestione">
          <v-card flat>
            <v-card-text>
              <v-card
                :class="{
                  'elevation-4 grey darken-4': !fromMenu,
                  'elevation-4 grey darken-4': fromMenu
                }"
              >
                <v-card-title v-if="!fromMenu">
                  <h3 class="headline mb-0">
                    Usa come prodotto
                  </h3>
                  <v-spacer></v-spacer>
                  <v-switch :disabled="keepSync || false" class="prodTypeToggle" v-model="currentProd.extraProps.isProdotto"></v-switch>
                </v-card-title>
                <v-card-title v-if="fromMenu">
                  <h3 class="headline mb-0">
                    Dettagli voce menu
                  </h3>
                </v-card-title>
                <v-card-text v-if="currentProd.extraProps.isProdotto || currentProd.isComb">
                  <v-text-field
                    class="mb-3"
                    v-if="!fromMenu"
                    type="number"
                    label="Disponibilità"
                    hint="Lasciare vuoto per disponibilità illimitata. Disponibilità che va a scalare indipendentemente dal giorno."
                    v-model="currentProd.disponibilitaAssoluta"
                    @change="changeAvailability"
                    pattern="[0-9]"
                    min="0"
                    persistent-hint
                  ></v-text-field>
                  <v-text-field
                    v-if="!fromMenu"
                    type="number"
                    label="Disponibilità giornaliera"
                    hint="Lasciare vuoto per disponibilità giornaliera illimitata"
                    v-model="currentProd.disponibilita"
                    pattern="[0-9]"
                    min="0"
                    persistent-hint
                  ></v-text-field>
                  <v-text-field
                    class="mb-3"
                    v-if="!fromMenu"
                    type="number"
                    label="Disponibilità giornaliera base"
                    hint="Lasciare vuoto per disponibilità illimitata. Ogni giorno la disponibilità sarà aggiornata a questo valore in un orario specifico."
                    v-model="currentProd.disponibilitaBase"
                    pattern="[0-9]"
                    min="0"
                    persistent-hint
                  ></v-text-field>         
                  <v-text-field
                    class="mb-3"
                    v-if="!fromMenu"
                    type="number"
                    label="Giorni necessari alla preparazione"
                    hint="Lasciare vuoto per indicare che il prodotto è sempre disponibile. Indicare altrimenti i giorni necessari alla preparazione."
                    v-model="currentProd.manufacturingDays"
                    pattern="[0-9]"
                    max="7"
                    persistent-hint
                  ></v-text-field>
                  <PriceEditor
                    @setprice="setPrice"
                    :listinoDaMenu="fromMenu ? listinoDaMenu : false"
                    v-model="currentProd.prezzo"
                    type="prod"
                    :soloMetti="true"
                    :disabled="(keepSync || false) && !currentProd.isComb"
                  />
                  <v-select
                    v-if="currentProd.extraProps.a_peso"
                    style="width: unset; flex: none"
                    :items="scalaPesi"
                    v-model="currentProd.scalaPeso"
                    label="Scala di peso dell'articolo"
                    persistent-hint
                    hint="Questa opzione determina la scala di peso da applicare al prezzo (es: 1€ al Kg)"
                    item-text="text"
                  ></v-select>
                  <template v-if="!keepSync">
                    <v-switch
                      :persistent-hint="true"
                      class="showHint"
                      hint="Altrimenti verranno ereditate dai gruppi"
                      @change="toggleOverrideStampanti"
                      primary
                      label="Sovrascrivi stampanti"
                      v-model="overrideStampanti"
                    ></v-switch>
                    <v-select
                      v-if="overrideStampanti"
                      chips
                      multiple
                      :items="stampanti"
                      v-model="currentProd.stampante"
                      label="Selezionare la stampanti di uscita"
                      item-value="name"
                      item-text="name"
                    ></v-select>
                  </template>
                  <template v-if="!keepSync">
                    <v-select :items="reparti" v-model="currentProd.reparto" label="Reparto" item-value="code" item-text="label"></v-select>
                  </template>
                  <v-layout v-bind="layoutBreakpoints" wrap>
                    <v-checkbox
                      :persistent-hint="true"
                      class="showHint"
                      hint="Questo prodotto identifica il coperto"
                      label="Coperto"
                      @click.native="update"
                      v-model="currentProd.extraProps.coperto"
                    ></v-checkbox>
                    <v-checkbox
                      :persistent-hint="true"
                      class="showHint"
                      hint="Questo prodotto verrà marcato come vegetariano"
                      label="Vegetariano"
                      @click.native="update"
                      v-model="currentProd.extraProps.vegetariano"
                    ></v-checkbox>
                    <v-checkbox
                      :persistent-hint="true"
                      class="showHint"
                      hint="Questo prodotto verrà marcato come vegano"
                      label="Vegano"
                      @click.native="update"
                      v-model="currentProd.extraProps.vegano"
                    ></v-checkbox>
                    <v-checkbox
                      :persistent-hint="true"
                      class="showHint"
                      hint="Questo prodotto verrà marcato come surgelato"
                      label="Surgelato"
                      @click.native="update"
                      v-model="currentProd.extraProps.surgelato"
                    ></v-checkbox>
                  </v-layout>
                  <v-layout v-bind="layoutBreakpoints" wrap>
                    <v-checkbox
                      :persistent-hint="true"
                      class="showHint"
                      hint="Questo prodotto verrà gestito a peso e non a porzioni"
                      label="A peso"
                      @click.native="update"
                      v-model="currentProd.extraProps.a_peso"
                    ></v-checkbox>                    
                     <v-checkbox
                      :persistent-hint="true"
                      class="showHint"
                      hint="Questo prodotto obbliga ad usare la carta di credito"
                      label="Carta di credito forzata"
                      @click.native="update"
                      v-model="currentProd.extraProps.onlyCreditCard"
                    ></v-checkbox>             
                    <v-checkbox
                      :persistent-hint="true"
                      class="showHint"
                      hint="Questo prodotto non somma al carico degli slot di consegna"
                      label="Carico Zero"
                      @click.native="update"
                      v-model="currentProd.noProductionCost"
                    ></v-checkbox>
                    <v-checkbox
                      v-if="this.fromMenu && !['tag'].includes(currentProd.tipo)"
                      :persistent-hint="true"
                      class="showHint"
                      hint="Questo prodotto non è disponibile fino a domani"
                      label="Indisponibile ora"
                      @click.native="update"
                      v-model="hiddenUntilTomorrow"
                    ></v-checkbox>
                  </v-layout>
                  <v-select
                    :items="allergeni"
                    :persistent-hint="true"
                    class="showHint"
                    hint="Indicare eventuali allergeni presenti nel prodotto"
                    v-model="currentProd.extraProps.iconeAllergeni"
                    label="Allergeni extra"
                    multiple
                    item-value="CATEGORIA"
                    item-text="CATEGORIA"
                  ></v-select>
                </v-card-text>
              </v-card>
            </v-card-text>
          </v-card>
          <v-card flat v-if="!fromMenu">
            <v-card-text>
              <v-card class="elevation-4 grey darken-4">
                <v-card-title>
                  <h3 class="headline mb-0">
                    Usa come variante
                  </h3>
                  <v-spacer></v-spacer>
                  <v-switch :disabled="keepSync || false" class="prodTypeToggle" v-model="currentProd.extraProps.isVariante"></v-switch>
                </v-card-title>
                <v-card-text v-if="currentProd.extraProps.isVariante">
                  <v-layout v-bind="layoutBreakpoints" wrap>
                    <v-checkbox
                      :persistent-hint="true"
                      class="showHint"
                      hint="Sarà possibile aggiungere e togliere questa variante"
                      @click.native="update"
                      label="Più/Meno"
                      v-model="currentProd.extraProps.toglibile"
                    ></v-checkbox>
                    <v-checkbox
                      :persistent-hint="true"
                      class="showHint"
                      hint="Sarà possibile specificare la quantità"
                      @click.native="update"
                      label="Quantificabile"
                      v-model="currentProd.extraProps.quantificabile"
                    ></v-checkbox>
                    <!-- <v-checkbox
                      v-if="!keepSync"
                      @change="settingAutoIngr"
                      :persistent-hint="true"
                      class="showHint"
                      hint="Quando aggiunta ad un prodotto verrà automaticamente inserita tra gli ingredienti"
                      @click.native="update"
                      label="Auto-ingrediente"
                      v-model="currentProd.extraProps.autoIngrediente"
                    ></v-checkbox>
                    //-->
                  </v-layout>
                  <PriceEditor
                    @setprice="setPrice"
                    :listinoDaMenu="fromMenu ? listinoDaMenu : false"
                    v-model="currentProd.prezzo"
                    :soloMetti="!currentProd.extraProps.toglibile"
                    type="var"
                    :disabled="(keepSync || false) && !currentProd.isComb"
                  />
                </v-card-text>
              </v-card>
            </v-card-text>
          </v-card>
          <v-card flat v-if="!fromMenu">
            <v-card-text>
              <v-card class="elevation-4 grey darken-4">
                <v-card-title>
                  <h3 class="headline mb-0">
                    Usa come ingrediente
                  </h3>
                  <v-spacer></v-spacer>
                  <v-switch :disabled="keepSync || false" class="prodTypeToggle" v-model="currentProd.extraProps.isIngrediente"></v-switch>
                </v-card-title>
                <v-card-text v-if="currentProd.extraProps.isIngrediente">
                  <v-layout v-bind="layoutBreakpoints" wrap>
                    <!-- <v-checkbox
                      v-if="!keepSync"
                      @change="settingAutoVar"
                      :persistent-hint="true"
                      class="showHint"
                      hint="Quando aggiunto ad un prodotto verrà automaticamente inserito tra le varianti"
                      @click.native="update"
                      label="Auto-variante"
                      v-model="currentProd.extraProps.autoVariante"
                    ></v-checkbox>
                    //-->
                    <v-checkbox
                      @change="settingForceAllergene"
                      :persistent-hint="true"
                      class="showHint"
                      hint="Gli ingredienti verranno automaticamente marcati come allergeni quando necessario, qualora un ingrediente non venisse marcato correttamente come allergene è possibile forzarlo con l'opzione corrente"
                      @click.native="update"
                      label="Forza allergene"
                      v-model="currentProd.extraProps.forzaAllergene"
                    ></v-checkbox>
                    <v-select
                      v-if="currentProd.extraProps.forzaAllergene"
                      :items="allergeni"
                      :persistent-hint="true"
                      class="showHint"
                      hint="Indicare a quale categoria di allergeni appartiene l'ingrediente"
                      v-model="currentProd.extraProps.overrideIcona"
                      label="Seleziona la categoria di allergeni"
                      item-value="CATEGORIA"
                      item-text="CATEGORIA"
                    ></v-select>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab href="#media" ripple>Media</v-tab>
        <v-tab-item class="media" value="media">
          <v-card flat>
            <v-card-text>
              <v-container fluid grid-list-md>
                <v-layout row justify-center wrap>
                  <v-flex xs12 sm6 md3>
                    <v-select
                      v-if="currentProd.tipo == 'prod'"
                      :items="imageTypes"
                      v-model="currentProd.extraProps.imageType"
                      label="Dimensione delle immagini"
                      persistent-hint
                      hint="Questa opzione determina la grandezza delle immagini all'interno dell'applicazione di Tapmenu"
                      item-text="text"
                      style="margin-bottom: 24px"
                    ></v-select>
                    <v-btn primary block style="min-height: 36px" @click.stop="onFocus">Cerca nel tuo PC</v-btn>
                    <v-dialog v-model="imagesDialog" persistent width="400px" style="display: none">
                      <template v-slot:activator="{ on }">
                        <v-btn primary block v-on="on">Cerca con Google</v-btn>
                      </template>
                      <v-card>
                        <v-card-title>
                          <div class="headline">
                            Scegli una immagine
                          </div>
                        </v-card-title>
                        <v-card-text class="g-images">
                          <!--<v-carousel ref="carousel" light :cycle="false">
                            <v-carousel-item v-for="(image,i) in images" v-bind:src="`${image.base64prefix}${image.image}`" :key="i">
                              <span class="imageSize">{{image.width}}x{{image.height}}</span>
                            </v-carousel-item>
                          </v-carousel>-->
                          <v-text-field
                            hide-details
                            class="img-descr"
                            :disabled="!overrideDescrState"
                            label="Descrizione personalizzata"
                            @blur="
                              searchPage = 1
                              searchImages()
                            "
                            v-model="overrideDescr"
                          >
                            <v-icon slot="append-outer" class="lock-button" @click="toggleDescrOverride">
                              {{ overrideDescrState ? 'lock_open' : 'lock' }}
                            </v-icon>
                          </v-text-field>
                          <v-container fluid grid-list-md>
                            <v-layout row wrap>
                              <v-flex class="xs4" v-for="(image, i) in images" :key="i">
                                <v-card>
                                  <v-img @click.native="useImage(i)" :src="`${image.base64prefix}${image.image}`" height="100px">
                                    <div class="img-size">
                                      {{ image.width }}
                                      x
                                      {{ image.height }}
                                    </div>
                                  </v-img>
                                </v-card>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn
                            icon
                            @click.native="
                              searchPage++
                              searchImages(true)
                            "
                          >
                            <v-icon>expand_more</v-icon>
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn class="green--text darken-1" flat="flat" @click.native="useImage(false)">Annulla</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <v-select
                      v-if="this.fromMenu && ['tag'].includes(currentProd.tipo)"
                      :items="viewTypes"
                      label="Tipo di visualizzazione del gruppo"
                      style="margin-top: 24px"
                      v-model="viewType"
                    ></v-select>
                  </v-flex>
                  <v-flex style="max-width: 300px" d-flex xs12 sm6 md3>
                    <input
                      v-validate="{
                        rules: {
                          image: true,
                          size: maxImageSize
                        }
                      }"
                      style="display: none"
                      type="file"
                      :multiple="false"
                      ref="fileInput"
                      @change="onFileChange"
                      name="immagine prodotto"
                    />
                    <img @click.stop="onFocus" :src="previewUrl" @error="handleImgErr" />
                    <span class="red--text text-xs-center">{{ imgValidation }}</span>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>

      <v-btn fixed dark fab bottom right :disabled="canSave()" @click.native="save" class="orange floatingBtn">
        <v-icon>save</v-icon>
      </v-btn>
    </v-container>
  </v-slide-y-transition>
</template>

<script>
/**
 * View di modifica di Tag/ProdVarIngr
 * @module components/common/ProdEditor
 */
import breakpoint from '@/breakpoints.js'
import { mapState } from 'vuex'

export default {
  name: 'prodEditor',
  /**
   * @prop edited {object} - L'oggetto modificato
   * @prop fromMenu {boolean} - Indica se l'oggetto proviene dalla libreria o dal menu
   * @prop listinoDamenu {boolean} -Indica se il listino da utilizzare è quello del menu
   * oppure quello globale
   * @prop inComb {boolean} - Indica se si sta modificando qualcosa all'interno di una combinazione
   */
  props: ['edited', 'fromMenu', 'listinoDaMenu', 'inComb'],
  mixins: [breakpoint],
  beforeMount() {
    if (this.$route.params.hasOwnProperty('prod')) {
      this.setCProd(this.$route.params.prod)
    } else if (!this.fromMenu) {
      this.$router.back()
    }

    this.$store.dispatch('TOOLBAR_ACTIONS', [
      {
        icon: 'arrow_back',
        text: 'Indietro',
        callback: () => {
          this.$router.back()
        }
      }
    ])
  },
  created() {
    this.uniqueValidation()
  },
  data: function() {
    return {
      overrideStampanti: false,
      currentProd: null,
      tavolinuxLang: 'IT',
      currentLang: 'IT',
      currentLangExt: 'IT',
      active: 'anagra',
      toUpload: null,
      previewSrc: null,
      searchText: '',
      searchPage: 1,
      images: [],
      imagesDialog: false,
      overrideDescrState: false,
      overrideDescr: '',
      specificDateSelector: false,
      specificDate: '',
      specificDateFormatted: '',
      imageTypes: [
        { text: 'Usa impostazione globale', value: null },
        { text: 'Piccole', value: 'S' },
        { text: 'Medie', value: 'M' },
        { text: 'Grandi', value: 'L' }
      ],
      scalaPesi: [
        {
          text: 'Kg',
          value: 'kg'
        },
        {
          text: 'Hg',
          value: 'hg'
        },
        {
          text: 'Gr',
          value: 'gr'
        }
      ],
      barCodesOk: true,
      mandatoryCodeOk: true,
      viewTypes: [
        { text: 'Verticale', value: 'vertical' },
        { text: 'Orizzontale', value: 'horizontal' },
        { text: 'Lista senza Immagini', value: 'no-image-list' },
        { text: 'Lista con Immagini', value: 'image-list' },
      ],
      viewType: 'image-list',
      hiddenUntilTomorrow: false
    }
  },
  computed: {
    titoloVarIngr() {
      if (['tag', 'comb'].includes(this.currentProd.tipo)) return 'Varianti/Ingredienti di default'
      else return 'Varianti/Ingredienti'
    },
    currentListino() {
      return this.$store.getters.currentListino
    },
    previewUrl() {
      return utils.getImgUrl(this.previewSrc || this.currentProd.img)
    },
    imgValidation() {
      return this.errors.items.map(error => error.msg).join(', ')
    },
    maxImageSize() {
      return utils.MAX_IMAGE_SIZE
    },
    tags() {
      return this.$store.getters.Tag
    },
    prodVarIngr() {
      return this.$store.getters.ProdVarIngr
    },
    keepSync() {
      return this.$store.getters.User.keepSync
    },
    allergeni() {
      return this.$store.getters.Allergeni
    },
    layoutBreakpoints() {
      if (this.$breakpoint.smAndDown) return { column: true }
      else return { row: true }
    },
    stampanti() {
      return this.$store.getters.stampanti.filter(s => s.name != 'CONTO')
    },
    reparti() {
      return this.$store.getters.reparti.map(r => ({
        code: r.code,
        vat: r.vat,
        label: `Reparto ${r.code} IVA ${r.vat}%`
      }))
    },    
  },
  watch: {
    edited: {
      handler(newV) {
        this.setCProd(newV.rowContent)

        if (!newV.rowImage) {
          this.toUpload = null
          this.previewSrc = null
        } else {
          this.toUpload = newV.rowImage
          this.previewSrc = newV.rowPreviewImage
        }

        this.viewType = newV.rowViewType ? newV.rowViewType : 'image-list'
        this.active = 'anagra'
      },
      deep: true
    },

    specificDate(val) {
      this.specificDateFormatted = this.formatDate(this.specificDate)
    },

    imagesDialog(newV) {
      if (newV) {
        this.images = []
        this.searchImages()
      }
    }
  },
  methods: {   
    setCheckboxClass(current) {
      if (current.tipo == 'var' && !current.extraProps.isIngrediente) {
        return 'prodTypeToggle' 
      } else {
        return 'showWhenVariant'
      }
    },
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate(date) {
      if (!date) return null
      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    setCProd(prod) {
      let currP

      if (prod != null) {
        // gestisci l'override delle stampanti
        currP = Object.assign({}, prod)
        if (currP.stampante != null) {
          Object.assign(currP, {
            stampante: currP.stampante != '' ? currP.stampante.split(',') : []
          })
          this.overrideStampanti = true
        } else {
          this.overrideStampanti = false
        }
        // gestisci la scala di peso di un articolo nuovo O precedentemente inserito senza scala
        if (currP.scalaPeso == null) currP.scalaPeso = 'kg'

        // gestisci i record senza billDescription (vecchie strutture)
        if (currP.billDescription == null) {
          currP.billDescription = []
        }

        if (currP.billDescription.length == 0)
          currP.billDescription.push({
            lingua: 'IT',
            main: true,
            contenuto: ''
          })

        // fix for mandatoryIngredients
        if (currP.tipo == 'prod' && currP.extraProps.mandatoryIngredients == null) currP.extraProps.mandatoryIngredients = []

        // add missing field
        if (currP.tipo == 'prod') {
          currP.extraProps.mandatoryIngredients.forEach((ingredient) => {
            if (!ingredient.hasOwnProperty('maxRequiredQuantity')) {
              ingredient.maxRequiredQuantity = '';
              ingredient.variantsTag = '';
              ingredient.maxVariantsTag = '';
              ingredient.suggestionDescr = '';
            }
          });
        }

        // set the hidden until tomorrow flag accordingly
        if (this.fromMenu && currP.hiddenUntil != null) {
          const now = new Date()
          const hiddenUntilDate = new Date(currP.hiddenUntil)
          this.hiddenUntilTomorrow = hiddenUntilDate > now
        }

        // copy trendCustomProperties.future
        if (currP.trendCustomProperties != null && currP.trendCustomProperties.futureReservationDays != null) {
          this.specificDate = currP.trendCustomProperties.futureReservationDays[0].split('T')[0]
        }
      } else {
        // nuovo prodotto
        currP = null
      }
      // aggiorna la mia copia
      this.currentProd = currP
    },
    toggleOverrideStampanti(v) {
      if (v) {
        this.currentProd.stampante = []
      } else {
        this.currentProd.stampante = null
      }
    },
    onChipSort(indexes, target) {
      let elem = target.splice(indexes.oldIndex, 1).pop()
      target.splice(indexes.newIndex, 0, elem)
    },
    onChipABCsort(key, newV) {
      this.currentProd[key] = newV
    },
    changeAvailability(value) {
      // if we set a 0 value to availability, ALL availability should be 0
      if (value === "0")
        this.currentProd.disponibilita = "0";
    },
    save() {
      const toSave = Object.assign({}, this.currentProd);

      if (toSave.stampante != null) {
        toSave.stampante = toSave.stampante.join(',')
      }

      if (toSave.tipo != 'tag' || (toSave.hasOwnProperty('isComb') && toSave.isComb)) {
        toSave.prezzo = toSave.prezzo.map(prezzo => {
          //const parsedPrezzop = prezzo.prezzop.toString().replace(/\./g, ',')
          //const parsedPrezzom = prezzo.prezzom.toString().replace(/\./g, ',')

          console.log('oldprices on save')
          console.log(prezzo.prezzop)
          console.log(prezzo.prezzom)

          let newPrices = Object.assign({}, prezzo, {
            prezzop: this.parse(prezzo.prezzop),
            prezzom: this.parse(prezzo.prezzom)
          })

          console.log('newprices on  save')
          console.log(newPrices.prezzop)
          console.log(newPrices.prezzom)

          return newPrices
        })
      }

      toSave.descrizione.forEach((d, i, arr) => {
        if (d.contenuto.length == 0 && d.main == false) arr.splice(i, 1)
      })

      // creation of extended description for groups
      if (toSave.tipo == 'tag' && !toSave.descrizioneEstesa) {
        toSave.descrizioneEstesa = []
      }

      // normal processing of descriptions
      toSave.descrizioneEstesa &&
        toSave.descrizioneEstesa.forEach((d, i, arr) => {
          if (d.contenuto.length == 0 && d.main == false) arr.splice(i, 1)
        })

      toSave.billDescription &&
        toSave.billDescription.forEach((d, i, arr) => {
          if (d.contenuto.length == 0 && d.main == false) arr.splice(i, 1)
        })

      if (this.specificDate != '')
        toSave.trendCustomProperties = {
          futureReservationDays: [this.specificDate + 'T00:00:00']
        }
      else  
        toSave.trendCustomProperties = null

      // fix wrong data in mandatoryIngredients
      if (toSave.extraProps.mandatoryIngredients != null &&
          toSave.extraProps.mandatoryIngredients.length > 0)
          {            
            toSave.extraProps.mandatoryIngredients = toSave.extraProps.mandatoryIngredients.filter(mi => {
              return mi.tag != ''
            }).map(element => {
              if (element.description == '')
                element.description = element.tag
              return element
            })
          }

      // set the hidden-until flag if requested
      if (this.fromMenu) {
        if (this.hiddenUntilTomorrow) {
          // compute tomorrow midnight
          const now = new Date()
          var expireDate = new Date(now)
          // TODO: fix this porky fix
          if (this.$store.getters.User.customercode == "9012274")
          {
            // go to next year
            expireDate.setDate(expireDate.getDate() + 365);
          }
          else
          {
            // go to tomorrow
            expireDate.setDate(expireDate.getDate() + 1)            
          }
          expireDate.setHours(4, 0, 0, 0)
          // save date
          toSave.hiddenUntil = expireDate
        } else {
          delete toSave.hiddenUntil
        }
      }

      if (this.fromMenu) {
        this.$emit('save', {
          target: toSave,
          img: this.toUpload,
          base64: this.toUpload != null ? this.previewSrc : null,
          viewType: this.viewType
        })
      } else {
        if (toSave.tipo != 'tag') {
          this.$store.dispatch('UPDATEPVI', {
            pvi: toSave,
            img: this.toUpload,
            callback: () => this.$router.back()
          })
        } else {
          this.$store.dispatch('UPDATETAG', {
            tag: toSave,
            img: this.toUpload,
            callback: () => this.$router.back()
          })
        }
      }

      this.currentLang = 'IT'
      this.currentLangExt = 'IT'
    },
    canSave() {
      const preposition1 = !(this.currentProd.extraProps.isProdotto || this.currentProd.extraProps.isIngrediente || this.currentProd.extraProps.isVariante)
      const preposition2 = !['tag', 'comb'].includes(this.currentProd.tipo)
      const preposition3 = utils.getMainDesc(this.currentProd).length == 0
      const preposition4 = !this.barCodesOk

      const canSave = (preposition1 && preposition2) || preposition3 || preposition4

      return canSave
    },
    update() {
      this.$forceUpdate()
    },
    setPrice(newPrezzo) {
      this.currentProd.prezzo = newPrezzo
    },
    getMainDesc(item) {
      return utils.getMainDesc(item)
    },
    addGruppo(gruppo, unique) {
      if (unique) {
        if (this.currentProd.padre == gruppo) this.currentProd.padre = null
        else this.currentProd.padre = gruppo
        return
      }

      let i = this.currentProd.tags.indexOf(gruppo)
      
      if (i == -1) {
        this.currentProd.tags.push(gruppo)
        if(this.currentProd.tipo != 'ingr' && this.currentProd.tipo != 'var') {
            this.currentProd.varIngr = this.currentProd.tags.reduce((c, n) => {
                return [
                    ...c,
                    ...(
                    this.tags.find(t => t._id == n) || {
                        varIngr: []
                    }
                    ).varIngr
                ]
            }, [])
        }
        
      } else {
          this.currentProd.tags.splice(i, this.currentProd.tags.length)
      }
    },
    addVarIngr(varIngr) {
      let i = this.currentProd.varIngr.indexOf(varIngr)

      if (i == -1 && this.checkChipTree(this.currentProd._id, varIngr, 'varIngr')) {
        this.currentProd.varIngr.push(varIngr)
      } else {
        this.currentProd.varIngr.splice(i, 1)
      }
    },
    checkChipTree(prod_id, chip, type) {
      // this function checks for doubled variants in varIngr nested products
      // looking forward inside product variants and recursively down 
      // on the tree
      let that = this

      if (!prod_id) return true

      if (prod_id == chip._id) return false

      return this.prodVarIngr
        .find(item => item._id == chip)
        [type].reduce((a, b) => {
          return a && that.checkChipTree(prod_id, that.prodVarIngr.find(pdv => pdv._id == b)._id, type)
        }, true)
    },
    setDescr(descr) {
      this.currentProd.descrizione = descr
    },
    setDescrExt(descr) {
      this.currentProd.descrizioneEstesa = descr
    },
    setDescrConto(descr) {
      this.currentProd.billDescription = descr
    },
    changeLang(lang) {
      this.currentLang = lang
    },
    changeLangExt(lang) {
      this.currentLangExt = lang
    },
    onFileChange($event) {
      const files = $event.target.files || $event.dataTransfer.files

      setTimeout(() => {
        if (files && files.length > 0 && !this.errors.items.length) {
          this.toUpload = files[0]

          var reader = new FileReader()
          reader.onload = () => {
            this.previewSrc = reader.result
          }
          reader.readAsDataURL(files[0])
        } else {
          this.previewSrc = null
        }
      })
    },
    onFocus() {
      this.$refs.fileInput.click()
    },
    handleImgErr() {
      this.currentProd.img = null
    },
    generateCode() {
      let dispatchString = ''
      if (this.currentProd.tipo == 'tag') {
        dispatchString = 'GETNEXTTAG'
      } else {
        dispatchString = 'GETNEXTPVI'
      }
      this.$store.dispatch(dispatchString, {
        callback: data => {
          if (data.next) {
            this.currentProd.ctvlx = data.next
          }
        }
      })
    },
    iconUrl(icon) {
      return utils.getImgUrl(icon)
    },
    searchImages(loadMore = false) {
      let searchDescr = ''
      if (this.overrideDescrState && this.overrideDescr != '') {
        searchDescr = this.overrideDescr.replace(/[\/\\#()$%":*?<>{}]/g, ' ')
      } else {
        let mainDescription = utils.getMainDesc(this.currentProd)
        mainDescription = mainDescription.replace(/[\/\\#()$%":*?<>{}]/g, ' ')
        searchDescr = encodeURIComponent(mainDescription)
      }

      this.$store.dispatch('SEARCHIMAGES', {
        search: searchDescr,
        page: this.searchPage,
        callback: images => {
          if (loadMore) this.images = [...this.images, ...images]
          else this.images = images
        }
      })
    },
    useImage(confirmIndex) {
      if (confirmIndex !== false) {
        let curr = this.images[confirmIndex]
        this.toUpload = utils.dataURItoBlob(`${curr.base64prefix}${curr.image}`)
        this.previewSrc = `${curr.base64prefix}${curr.image}`
        this.imagesDialog = false
      } else {
        this.imagesDialog = false
      }
    },
    settingAutoIngr(ev) {
      if (ev) this.currentProd.extraProps.isIngrediente = true
    },
    settingAutoVar(ev) {
      if (ev) this.currentProd.extraProps.isVariante = true
    },
    settingForceAllergene(ev) {
      if (ev) {
        this.currentProd.extraProps.forzaAllergene = true
        this.currentProd.extraProps.overrideIcona = this.allergeni[0].CATEGORIA
      }
    },
    toggleDescrOverride() {
      if (this.overrideDescrState) {
        this.overrideDescr = ''
        this.overrideDescrState = false
        this.searchImages()
      } else {
        this.overrideDescrState = true
      }
    },
    uniqueValidation() {
      // CUSTOM VALIDATION RULE FOR BARCODE
      this.$validator.extend('uniqueValidation', {
        getMessage(field, args) {
          return 'Questo bar code è già stato aggiunto.'
        },
        validate: (value, args) => {
          let isOk = true

          this.currentProd.barCodes.forEach((element, index) => {
            if (index != args[0]) {
              if (element.trim() === value.trim()) {
                isOk = false
              }
            }
          })

          if (isOk) {
            this.prodVarIngr.forEach(article => {
              if (article._id != this.currentProd._id) {
                article.barCodes.forEach(element => {
                  if (element.trim() === value.trim()) {
                    isOk = false
                  }
                })
              }
            })
          }

          if (isOk) {
            this.barCodesOk = true
          } else {
            this.barCodesOk = false
          }

          return isOk
        }
      })
    },
    addBarCode() {
      this.currentProd.barCodes.push('')
      this.barCodesOk = false
    },
    deleteBarCode(index) {
      this.currentProd.barCodes.splice(index, 1)
    },
    addMandatoryIngredient() {
      this.currentProd.extraProps.mandatoryIngredients.push({ tag: '', description:'', requiredQuantity: '1', maxRequiredQuantity: '',  variantsTag: '', maxVariantsTag: '', suggestionDescr: '' })
      this.mandatoryCodeOk = false
    },
    deleteMandatoryIngredient(index) {
      console.log(this.currentProd.extraProps.mandatoryIngredients)
      this.currentProd.extraProps.mandatoryIngredients.splice(index, 1)
    },
    confirmMandatoryIngredient(value) {
      if (value != '') {
        this.mandatoryCodeOk = true
      } else {
        this.mandatoryCodeOk = false
      }
    },
    confirmRequired(value) {
      // check if the required so can pass the information to the variable that is checked to disable the save button
      if (value != '') {
        this.barCodesOk = true
      } else {
        this.barCodesOk = false
      }
    },
    onCloneProductVariants() {
      this.$emit('cloneVariants', this.currentProd)
    },
    parse(value) {
      let parsed = value != null ? value.toString().replaceAll(',', '.') : null
      let isNumber = parsed ? parseFloat(parsed) : null

      if (isNumber == null || isNaN(isNumber)) {
        parsed = '0'
      }

      return parsed
    },
    clearSpecificDate() {
      this.specificDate = this.specificDateFormatted = ''
    },
    getAllUsedTags(index) {
      // get all already used tags
      var alreadyUsed = []
      if (this.currentProd.extraProps.mandatoryIngredients != null) {
        this.currentProd.extraProps.mandatoryIngredients.map((ingredient, internalIndex) => {
          if (ingredient.tag != '' && (index != internalIndex))
              alreadyUsed.push(ingredient.tag)
        })
      }
      // match all unique existing tags in products
      var result = Array.from(
        new Set(
          [].concat.apply(
            [],
            this.$store.getters.ProdVarIngr.filter(pvi => pvi.hasOwnProperty('constraintTags') && pvi.constraintTags.length > 0).map(pvi => {
              return pvi.constraintTags
            })
          )
        )
      ).filter(element => {
        return !alreadyUsed.includes(element)
      }).sort()
      return result
    }
  }
}
</script>

<style lang="stylus" scoped>
.showHint >>> .input-group__details {
    display: block !important;
}

.imageSize {
    position: absolute;
    top: 10px;
    left: 10px;
    background: #ddd;
    padding: 5px;
}

.cod-container {
    margin-top: 8px;
    display: flex;
}

.pEdit {
    background: #424242;
    padding: 8px 16px 8px;
}

.prodTypeToggle {
    flex-grow: 0;
    min-width: 50px;
    margin-bottom: 0;
}

.fromMenu >>> .tabs__items {
    border: none;
}

.anteprima {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    margin-top: 24px;
}

img {
    max-width: 300px;
    cursor: pointer;
}

.tabs {
    height: 100%;
}

.tabs >>> .tabs__items {
    overflow-y: auto;
    height: calc(100% - 48px);
}

.showWhenVariant {
    display: none;
}

.tabs__content.media {
    height: 100%;

    >>> .card {
        min-height: 100% !important;

        .card__text {
            min-height: 100%;
        }
    }
}

.g-images {
    padding: 0 10px;

    .container {
        overflow: auto;
        max-height: 335px;
    }
}

.img-size {
    position: absolute;
    left: 5px;
    bottom: 5px;
    background: rgba(66, 66, 66, 0.5);
    padding: 0 10px;
}

.lock-button {
    pointer-events: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ProdEditor.vue